module.exports = __webpack_public_path__ + "dd6c224d7fa0b193a872816d991c6a9b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/MasahikoNagai.jpg
 ** module id = 504
 ** module chunks = 1
 **/